import { filter } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as mobileMenu from '../../actions/mobile-menu';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'edge-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss']
})
export class GlobalMobileMenuComponent implements OnInit {
  constructor(
    private store: Store<fromRoot.State>,
    private router: Router
  ) {}
  showProductDropdown = false;
  showNews = false;
  environment = environment;

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event) => {
          return `${event}`.startsWith('NavigationStart');
        })
      )
      .subscribe(() => {
        this.toggleMobileMenu(false);
      });

    if (!environment.production) {
      this.showNews = true;
    }
  }

  /**
   * Toggle the product dropdown menu to display the sports
   */
  toggleProductDropdown(): void {
    this.showProductDropdown = !this.showProductDropdown;
  }

  toggleMobileMenu(arg: boolean): void {
    this.store.dispatch(mobileMenu.ToggleMobileMenuAction(arg));
  }
}
